import axios from '@/api/requests/axios'

export default {
  getAll: (params) => axios.get(`/api/admin/v1/customers`, { params }),
  getCustomersDropdown: (params) => axios.get(`api/admin/v1/customers/drop-down`, { params }),
}
